import { DURATION_UNIT, SAVE_RESUME_MODE, EDIT_AFTER_SUBMISSION_MODE } from '../constants'

export const createEmptyParticipantSession = (overrides = {}) => ({
  saveResume: { mode: SAVE_RESUME_MODE.no, value: 30, unit: DURATION_UNIT.minutes },
  editAfterSubmission: { mode: EDIT_AFTER_SUBMISSION_MODE.no, value: 24, unit: DURATION_UNIT.hours },
  ...overrides,
})
